import React from 'react';
import classNames from 'classnames';
import styles from 'src/components/calendars/assets/calendars.module.scss';
import { FormError } from 'src/components/redux-form/FormError';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { DecoratedFormProps, InjectedFormProps, reduxForm } from 'redux-form';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import GeneralEnum from '../../../../../../../../../enumerables/general-enum';
import { asyncPersistIntakeSent } from '../../../../../../../../../store/actions/intakeSent-actions';

export interface IntakeSentFormData {
    intakes: any;
    student: number | string;
    isOne: boolean;
}

interface IntakeSentFormProps {
    student: any;
    initialValues: any;
}

type InjectedProps = InjectedFormProps<IntakeSentFormData, IntakeSentFormProps>;

const IntakeSentForm: React.FunctionComponent<InjectedProps & IntakeSentFormProps> = ({
    handleSubmit,
    error,
    dirty,
    student,
    initialValues,
    submitting,
}: InjectedProps & IntakeSentFormProps) => {
    const id = student?.id;
    const IntakeType = GeneralEnum ? GeneralEnum.getEnum('IntakeType') : {};

    const intakeTypeValues: SelectObject[] = getValFromEnum(IntakeType);

    return (
        <form onSubmit={handleSubmit} className={classNames(styles.form)}>
            <FormError error={error} />
            <FieldInput
                name="student"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name="isOne"
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />

            <FieldInput
                name={`intakes[${intakeTypeValues[0].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[0].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[1].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[1].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />

            <FieldInput
                name={`intakes[${intakeTypeValues[3].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[3].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[4].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[4].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />

            <FieldInput
                name={`intakes[${intakeTypeValues[5].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[5].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />

            <FieldInput
                name={`intakes[${intakeTypeValues[12].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[12].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />

            <FieldInput
                name={`intakes[${intakeTypeValues[6].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[6].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[14].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[14].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[15].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[15].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[16].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[16].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[17].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[17].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[18].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[18].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[19].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[19].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[20].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[20].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[21].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[21].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />
            <FieldInput
                name={`intakes[${intakeTypeValues[22].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[22].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />

            <FieldInput
                name={`intakes[${intakeTypeValues[23].value}]`}
                type="checkbox"
                wrapperConfig={{
                    label: intakeTypeValues[23].label,
                    classes: {
                        inputWrapper: 'customCheckbox customCheckboxWide customIntakeCheckboxWide',
                    },
                }}
            />

            <div>
                <button
                    type="submit"
                    className={classNames('btn', 'btn-success', 'mr-3')}
                    disabled={!dirty || submitting}
                >
                    <FontAwesomeIcon icon={faSave} /> Send
                </button>
            </div>
        </form>
    );
};

export default reduxForm<IntakeSentFormData, IntakeSentFormProps>({
    form: 'intake-form',
    enableReinitialize: true,
    onSubmit: async (data: IntakeSentFormData, dispatch: Dispatch<any>, props: any) => {
        await asyncPersistIntakeSent(
            {
                ...data,
            },
            dispatch,
        );
    },
    onSubmitSuccess(
        result: any,
        dispatch: Dispatch<any>,
        props: DecoratedFormProps<IntakeSentFormData, IntakeSentFormProps>,
    ) {
        toast.success(`Intake Forms were successfully sent.`);
    },
    onSubmitFail(errors: { _error: string }) {
        console.log('errors', errors);
        if (errors?._error) {
            toast.error(errors._error);
        }
    },
})(IntakeSentForm);
